export type SendTextPayload = { phone: string; message: string };

export const sendText = async ({ phone, message }: SendTextPayload) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/text`, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, message }),
    });
    return response.json();
};
